import styled from "styled-components"

// A real <img> (not a background-image div) so the browser reads its
// natural width/height and uses them for layout. Combined with
// `width: 100%; height: auto` on `.gl-home-banner__image` (see
// _banner.scss), the rendered height tracks the image's own aspect ratio,
// and the (in-flow, non-absolute) .gl-home-banner__container wraps it
// exactly — no `aspect-ratio` token, no cropping, no letterbox gap,
// regardless of what ratio an uploaded banner actually has.
const StyledBannerImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`
export default StyledBannerImage
